/**
 * Canonical user_type enum.
 *
 * Mirrors the `profiles.user_type` CHECK constraint:
 *   profiles_user_type_check: user_type IN ('internal','external')
 *
 * RULES (per project DRY/SRP mandate):
 *  - Single-select. A profile is exactly one of these.
 *  - This is an *identity bucket*, NOT a job title.
 *  - Job-function info (sales-rep, account-manager, designer,
 *    helpdesk-agent, super-admin, viber, etc.) lives in `profile_roles`.
 *    Never re-encode that here.
 *  - Permission checks: use CASL `ability.can(action, subject)`.
 *  - "Is this person a CIWG employee?" check: use
 *    `profilesService.isStaff(userType)` — the single canonical predicate.
 */
import { z } from "zod";

export const USER_TYPES = ["internal", "external"] as const;

export const UserTypeSchema = z.enum(USER_TYPES);

export type UserType = z.infer<typeof UserTypeSchema>;

export const USER_TYPE_LABELS: Record<UserType, string> = {
  internal: "Internal (CIWG Employee)",
  external: "External",
};

/** Canonical "is this profile a CIWG employee?" predicate. */
export const isStaffUserType = (ut: string | null | undefined): boolean =>
  ut === "internal";
